import { useRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import { useDndContext } from '@dnd-kit/core'
import {
  studioSettingsActions,
  MAX_ZOOM,
  MIN_ZOOM,
} from 'apps/studio/store/reducers/settings/studioSettings'
const { setZoom } = studioSettingsActions
import { currentZoomSelector } from 'apps/studio/store/selectors/studioSettings'
import { activeEntrySelector } from 'apps/formsCreationKit/store/selectors/entities'
import { activeStyledElementSelector } from 'apps/studio/store/selectors/pdf'
import { ElementToolbar } from 'apps/studio/components/pdfViewer/elements/ElementToolbar'
import { useTransformWrapper } from 'apps/studio/contexts/TransformWrapperContext'

export const ZoomableWorkspace = ({ children }) => {
  const dispatch = useDispatch()
  const currentZoom = useSelector(currentZoomSelector)
  const activeEntry = useSelector(activeEntrySelector)
  const { pdf_visibility } = activeEntry || {}
  const { active } = useDndContext()
  const activeStyledElement = useSelector(activeStyledElementSelector)
  const isDragging = !!active
  const [isMoving, setIsMoving] = useState(false)
  const showToolbar =
    activeStyledElement && pdf_visibility != 1 && !isDragging && !isMoving
  const { transformWrapperRef } = useTransformWrapper()
  const transformRef = useRef(null)

  useEffect(() => {
    if (currentZoom && transformWrapperRef.current) {
      const { positionX, positionY, scale } =
        transformWrapperRef.current.instance.transformState

      if (currentZoom === scale) {
        return
      }

      transformWrapperRef.current.setTransform(
        positionX,
        positionY,
        currentZoom
      )
    }
  }, [currentZoom])

  const setZoomLevel = ({ state }) => {
    const { scale } = state
    dispatch(setZoom({ zoom: scale }))
  }

  return (
    <>
      <TransformWrapper
        ref={transformWrapperRef}
        disabled={isDragging}
        initialScale={currentZoom}
        minScale={MIN_ZOOM}
        maxScale={MAX_ZOOM}
        centerOnInit={true}
        centerZoomedOut={false}
        limitToBounds={false}
        doubleClick={{
          excluded: [
            'page-element',
            'static-table--cell-chevron',
            'static-table--add-col',
            'static-table--add-row',
          ],
        }}
        onZoomStop={setZoomLevel}
        onZoom={({ state, zoomToElement }) => {
          if (state.scale < 0.1) {
            state.scale = MIN_ZOOM
            const closestEl = document.elementFromPoint(
              state.positionX,
              state.positionY
            )
            const el = document.querySelector('.page--wrapper')
            if (closestEl) {
              zoomToElement(closestEl, MIN_ZOOM)
            } else {
              zoomToElement(el, MIN_ZOOM)
            }
          }
          setIsMoving(true)
        }}
        onTransformed={() => {
          setIsMoving(true)
          clearTimeout(transformRef.current)
          transformRef.current = setTimeout(setIsMoving, 80, false)
        }}
        wheel={{
          wheelDisabled: true,
          step: 2,
          smoothStep: 0.005,
        }}
        panning={{
          wheelPanning: true,
          allowLeftClickPan: activeEntry ? false : true,
          excluded: [
            'page-element',
            'resize--handle',
            'static-table--drag-handle',
            'static-table--title',
            'static-table--resize-grip',
            'static-table--cell-chevron',
            'static-table--add-col',
            'static-table--add-row',
          ],
        }}
      >
        <TransformComponent>{children}</TransformComponent>
      </TransformWrapper>
      {showToolbar && (
        <ElementToolbar element={activeStyledElement} entry={activeEntry} />
      )}
    </>
  )
}
